<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
  >
    {{message}}
  </v-snackbar>

  <v-dialog persistent v-model="BlockingViolation" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-information-outline</v-icon>Blocking Value Violation</div>
          <p>Due to the Blocking Value set on the Client, the specified amount cannot be captured</p>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right mb-4">
          <v-btn class="white--text mr-3" small color="#2A353D" @click="BlockingViolation = false">
            ok
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Sell Money Market</v-toolbar-title>
    <v-spacer/>
    <span class="white--text caption font-weight-normal mr-3">Transacting Currency: {{Currency[0].CurrencyName}}</span>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="create">
    <v-card class="mt-3 pa-4" elevation="12">
      <v-data-table
        :error-messages="errors"
        v-model="selected"
        show-select
        :headers="selected.length == Termination_Allocations.length && selected.length != 0? full_termination_headers : partial_termination_headers"
        :fixed-header="true"
        :items="Termination_Allocations"
        item-key="AccountID"
        disable-pagination
        hide-default-footer
        class="my-allocations-table"
      >

        <template v-slot:top >
          <v-row>
            <v-col class="pb-0">
              <v-select
                outlined dense @change="getDeals(0, MMSale.CustodialID); getAccounts(MMSale.CustodialID); MMSale.allocation = []"
                v-model="MMSale.CustodialID"
                :items="DealCustodians"
                item-text="CustodianName"
                item-value="CustodianID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Custodian"
              ></v-select>
            </v-col>
            <v-col class="pb-0">
              <v-select
                outlined dense
                v-model="ActiveDealDetails"
                :items="Deals"
                item-text="Deal"
                item-value="Deal"
                placeholder="----"
                :rules="TextFieldRules"
                label="Money Market Deal"
              ></v-select>
            </v-col>
            <v-col class="pb-0">
              <v-select
                @change="__getInterestDenominator()"
                outlined dense
                v-model="MMSale.FldVar01"
                :items="Basis"
                item-text="BasisDesc"
                item-value="BasisIdAlpha"
                placeholder="----"
                :rules="TextFieldRules"
                label="Deal Base"
              ></v-select>
            </v-col>
          </v-row>

          <v-data-table
            v-if="view_summary == true"
            :headers="deal_summary_headers"
            :fixed-header="true"
            :items="[ActiveDeal]"
            disable-pagination
            hide-default-footer
            class="my-allocations-table"
          >

            <template v-slot:top >
              <span class="grey--text subtitle-1 font-weight-bold">Deal Summary</span>
            </template>

            <template v-slot:item.InstrumentValue="{ item }">
              {{Number(item.InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.MaturityValue="{ item }">
              {{Number(item.MaturityValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.Accrued="{ item }">
              {{Number(getAccruedInterest(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.DaysRun>
              {{DaysRun}}
            </template>

            <template v-slot:item.DaysToRun>
              {{DaysToRun}}
            </template>

            <template v-slot:footer >
              <v-divider class="pb-4"/>
            </template>

          </v-data-table>

          <div class="grey--text subtitle-1 font-weight-bold">Deal Beneficiaries</div>
          <span class="grey--text subtitle-2 font-weight-normal">(Select for early maturity)</span>
        </template>

        <template v-slot:footer >
          <v-divider class="pb-4"/>
          <span class="grey--text subtitle-1 font-weight-bold">Redistribution Values</span>
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="getInstrumentName(ActiveDeal.InstrumentID)"
                label="Instrument"
                readonly placeholder="----"
              ></v-text-field>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="DaysToRun"
                label="Tenor"
                type="number"
                readonly placeholder="----"
              ></v-text-field>
            </v-col>

            <v-col class="pb-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="Number(InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                label="Nominal Value"
                readonly placeholder="----"
              ></v-text-field>

              <v-row>
                <v-col class="py-0">
                  <v-select
                    outlined dense
                    v-model="ChargePercentage"
                    :items="ChargesBoolean"
                    item-text="Text"
                    item-value="Value"
                    placeholder="----"
                    label="Is Charge a Percentage?"
                  ></v-select>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="EarlyTerminationCharges"
                    label="Early termination charges"
                    type="number"
                    placeholder="----"
                    :rules="[
                      v => !!v || 'field is required'
                    ]"
                    :prefix="ChargePercentage ? '%' : Currency[0].CurrencySymbol"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-divider/>
          <v-row justify="space-between px-3">
            <span class="grey--text subtitle-1 font-weight-bold">Termination Directive</span>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" text small class="ml-2">
                {{CurrentTerminationDirective.TerminationDirectiveCode}}<v-icon color="#2A353D" class="ml-1">mdi-chevron-down</v-icon>
              </v-btn>
              </template>
              <v-list dense>
                <v-list-item v-for="Directive in TerminationDirectives" :key="Directive.TerminationDirectiveId" @click="CurrentTerminationDirective = Directive">
                  <v-list-item-title>
                    {{ Directive.TerminationDirectiveCode }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
          <v-divider/>

          <div v-if="CurrentTerminationDirective.TerminationDirectiveId != 1 && CurrentTerminationDirective.TerminationDirectiveId != 3" class="text-right mb-4 pt-7">
            <v-btn class="white--text mx-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
            <v-btn class="white--text" small color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
              <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
              submit
            </v-btn>          
          </div>

          <v-data-table
            v-if="CurrentTerminationDirective.TerminationDirectiveId == 1 || CurrentTerminationDirective.TerminationDirectiveId == 3"
            :headers="allocations_headers"
            :fixed-header="true"
            :items="MMSale.allocation"
            disable-pagination
            hide-default-footer
            class="my-allocations-table"
          >

            <template v-slot:top >
              <span class="grey--text subtitle-1 font-weight-bold pt-8">Redistribution Allocations</span>
              <v-spacer/>
              <v-btn v-if="CurrentTerminationDirective.TerminationDirectiveId == 1" class="text-right" @click="NewAllocation(MMSale.allocation)" x-small dark outlined fab absolute right color="#2A353D">
                <v-icon small >mdi-plus</v-icon>
              </v-btn>
            </template>

            <template v-slot:item.AccountID="{ item }">
              <v-select
                v-if="CurrentTerminationDirective.TerminationDirectiveId == 1"
                @change="getCurrentAccountBalance(item)"
                @click="setActiveAllocation(item, index)"
                background-color="#ffffff00"
                v-model="item.AccountID"
                :items="Accounts"
                :menu-props="{ top: true, offsetY: true }"
                item-text="AccountName"
                item-value="AccountID"
                solo flat class="Account ma-0 pa-0 pt-5"
                placeholder="----" dense
                :rules="[
                  v => !!v || 'field is required',
                  v => MMSale.allocation.filter(a => a.AccountID == item.AccountID).length < 2 || 'Account already selected'
                ]"
              ></v-select>

              <v-text-field
                v-else readonly
                background-color="#ffffff00"
                :value="ProprietaryAcc.AccountName"
                solo flat class="Account ma-0 pa-0 pt-5"
                hide-details dense
              ></v-text-field>
            </template>

            <template v-slot:item.FldNum04="{ item }">
              {{Number(getProfit(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.FldNum01="{ item }">
              {{Number(getMaturityValue(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.ChargeValue="{ item }">
              {{Number(getAllocationCharges(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.AllocationRate="{ item }">
              <v-text-field
                single-line
                color="#2A353D"
                v-model="item.AllocationRate"
                type="number"
                label="Rate"
                :rules="CurrentTerminationDirective.TerminationDirectiveId == 1 ? [
                  v => !!v || 'required'
                ] : null"
              ></v-text-field>
              <!-- {{Number(getAllocationRate(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}} -->
            </template>

            <template v-slot:item.OpeningBalance="{ item }">
              {{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template  v-slot:item.AllocationValue="{ item }">
              <v-text-field
                :readonly="CurrentTerminationDirective.TerminationDirectiveId == 3"
                v-model="item.AllocationValue"
                @keydown="getNetValueValidation(MMSale.allocation, item)"
                label="Amount"
                :rules="CurrentTerminationDirective.TerminationDirectiveId == 1 ? [
                  v => !!v || 'field is required',
                  v =>  v <= Number(item.OpeningBalance) - Number(item.ChargeValue) || 'Over allocated',
                ] : null"
                single-line
                type="number"
              ></v-text-field>
            </template>

            <template v-slot:item.action="{ item }">
              <v-icon v-if="CurrentTerminationDirective.TerminationDirectiveId == 1" small @click="removeAllocation(item, MMSale.allocation)">mdi-close</v-icon>
            </template>

            <template v-slot:footer >
              <v-divider class="mt-0"/>
              <v-row class="ml-2 mr-2">
                <v-col class="pb-0 pt-7" cols="2">
                <v-text-field
                  class="table-text-field"
                  light dense
                  :value="Number(getAllocatedValue(MMSale.allocation)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                  color="#2A353D"
                  label="Allocated Value"
                  readonly
                  :rules="[() => getAllocatedValue(MMSale.allocation).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) == InstrumentValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) || 'should match Norminal Value']"
                  :prefix="Currency[0].CurrencySymbol"
                ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-7">
                </v-col>
                <v-col class="pb-0 pt-7">
                <v-text-field
                  class="table-text-field"
                  light dense
                  :value="InstrumentValue != null ? Number(InstrumentValue - getAllocatedValue(MMSale.allocation)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0"
                  color="#2A353D"
                  label="Remaining Amount"
                  readonly
                ></v-text-field>
                </v-col>
                <v-col class="pb-0 pt-7" cols="6">
                  <div class="text-right mb-4 pt-7">
                    <v-btn class="white--text mx-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
                    <v-btn class="white--text" small color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
                      <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                      submit
                    </v-btn>          
                  </div>
                </v-col>
              </v-row>
            </template>
          </v-data-table>
        </template>

        <template v-slot:item.Split="{ item }">
          <v-row>
            <v-simple-checkbox
              :disabled="!selected.includes(item)"
              v-model="item.Split"
              @change="item.SplitValue = 0"
            ></v-simple-checkbox>

            <v-text-field
              class="ml-3 mt-3"
              v-if="item.Split == true"
              v-model="item.SplitValue"
              :rules="item.Split == true ? [
                v => !!v || 'field is required',
                v =>  v <= Number(item.AllocationValue)|| 'Exceeds Norminal Value!',
              ] : null"
              dense
              type="number"
            ></v-text-field>
          </v-row>
        </template>

        <template v-slot:item.FldNum05="{ item }">
          <v-text-field
            class="mt-3"
            v-model="item.FldNum05"
            :rules="[
              v => !!v || 'field is required'
            ]"
            dense
            type="number"
            sufix="%"
          ></v-text-field>
        </template>

        <template v-slot:item.AccountID="{ item }">
          {{allClientAccounts.filter(a => a.AccountID == item.AccountID).map(a => a.tblclient.MajorName)[0]}}   {{allClientAccounts.filter(a => a.AccountID == item.AccountID).map(a => a.tblclient.Forename)[0]}}
        </template>

        <template v-slot:item.AllocationValue="{ item }">
          {{Number(item.AllocationValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>

        <template v-slot:item.Accrued="{ item }">
          {{Number(getEachAccruedInterest(item.AllocationValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>

        <template v-slot:item.FldNum01="{ item }">
          {{Number(item.FldNum01).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>

      </v-data-table>
    </v-card>
  </v-form>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="edit">
    <span class="d-flex flex-row mt-2">
      <span class="grey--text caption font-weight-normal">ID: <span class="subtitle-2">{{currentSale.DealNumber}}</span></span>
      <v-spacer/>
      <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSale.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span v-if="currentSale.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSale.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentSale.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
    </span>
    <v-card class="mt-3 pa-4" elevation="12">
      <v-data-table
        :headers="termination_view_headers"
        :fixed-header="true"
        :items="CurrentSaleOriginalDeal.allocations"
        disable-pagination
        hide-default-footer
        class="my-allocations-table"
      >

        <template v-slot:top >
          <v-row>
            <v-col class="pb-0">
              <v-select
                outlined dense
                v-model="currentSale.CustodialID"
                :items="DealCustodians"
                item-text="CustodianName"
                item-value="CustodianID"
                placeholder="----" readonly
                :rules="TextFieldRules"
                label="Custodian"
              ></v-select>
            </v-col>
            <v-col class="pb-0">
              <v-text-field
                outlined dense
                :value="CurrentSaleOriginalDeal.BrokerNote + ' - ' + getInstrumentName(CurrentSaleOriginalDeal.InstrumentID)"
                readonly
                :rules="TextFieldRules"
                label="Money Market Deal"
              ></v-text-field>
            </v-col>
            <v-col class="pb-0">
              <v-select
                @change="__getInterestDenominator()"
                outlined dense
                v-model="currentSale.FldVar01"
                :items="Basis"
                item-text="BasisDesc"
                item-value="BasisIdAlpha"
                placeholder="----" readonly
                :rules="TextFieldRules"
                label="Deal Base"
              ></v-select>
            </v-col>
          </v-row>

          <v-data-table
            v-if="view_summary == true"
            :headers="deal_summary_headers"
            :fixed-header="true"
            :items="[CurrentSaleOriginalDeal]"
            disable-pagination
            hide-default-footer
            class="my-allocations-table"
          >

            <template v-slot:top >
              <span class="grey--text subtitle-1 font-weight-bold">Deal Summary</span>
            </template>

            <template v-slot:item.InstrumentValue="{ item }">
              {{Number(item.InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.MaturityValue="{ item }">
              {{Number(item.FldNum02).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.Accrued="{ item }">
              {{Number(getAccruedInterest(item)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.DaysRun>
              {{DaysRun}}
            </template>

            <template v-slot:item.DaysToRun>
              {{DaysToRun}}
            </template>

            <template v-slot:footer >
              <v-divider class="pb-4"/>
            </template>

          </v-data-table>

          <v-row>
            <v-col cols="2" class="py-0">
              <div class="grey--text subtitle-1 font-weight-bold">Deal Beneficiaries:</div>
            </v-col>
            <!-- <v-col class="py-0">
              <span class="grey--text subtitle-1 font-weight-bold"><v-icon small class="mr-2" color="success">mdi-checkbox-blank-circle</v-icon> Currently Running</span>
            </v-col>
            <v-col class="py-0">
              <span class="grey--text subtitle-1 font-weight-bold"><v-icon small class="mr-2" color="yellow">mdi-checkbox-blank-circle</v-icon> New Allocations</span>
            </v-col>
            <v-col class="py-0">
              <span class="grey--text subtitle-1 font-weight-bold"><v-icon small class="mr-2" color="red">mdi-checkbox-blank-circle</v-icon> Terminated</span>
            </v-col> -->
          </v-row>
        </template>

        <template v-slot:footer >
          <v-divider class="pb-4"/>
          <span class="grey--text subtitle-1 font-weight-bold">Redistributed Values</span>
          <v-row class="ml-1 mr-1">
            <v-col class="pb-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="getInstrumentName(CurrentSaleOriginalDeal.InstrumentID)"
                label="Instrument"
                readonly placeholder="----"
              ></v-text-field>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="DaysToRun"
                label="Tenor"
                type="number"
                readonly placeholder="----"
              ></v-text-field>
            </v-col>

            <v-col class="pb-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                :value="Number(currentSale.InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                label="Nominal Value"
                readonly placeholder="----"
              ></v-text-field>

              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="currentSale.FldNum01"
                label="Early termination charges"
                type="number" readonly
                placeholder="----"
                :prefix="Currency[0].CurrencySymbol"
              ></v-text-field>

              <div v-if="CurrentSaleOriginalDeal.FldInt01 == 1" class="text-right mb-4 pt-7">
                <v-btn class="white--text" small color="#2A353D" @click="closeEdit()">close</v-btn>       
              </div>
            </v-col>
          </v-row>

          <v-data-table
            v-if="CurrentSaleOriginalDeal.FldInt01 != 1"
            :headers="allocations_headers"
            :fixed-header="true"
            :items="CurrentSaleOriginalDeal.allocations.filter(a => a.Quantity == currentSale.SaleID)"
            disable-pagination
            hide-default-footer
            class="my-allocations-table"
          >

            <template v-slot:top >
              <span class="grey--text subtitle-1 font-weight-bold pt-8">Redistributed Allocation Details</span>
            </template>

            <template v-slot:item.AccountID="{ item }">
              <v-select
                background-color="#ffffff00"
                v-model="item.AccountID"
                :items="Accounts"
                :menu-props="{ top: true, offsetY: true }"
                item-text="AccountName"
                item-value="AccountID"
                hide-details solo flat class="Account ma-0 pa-0"
                readonly
                placeholder="----" dense
              ></v-select>
            </template>

            <template v-slot:item.FldNum02="{ item }">
              {{Number(item.FldNum02).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.FldNum01="{ item }">
              {{Number(item.FldNum01).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.ChargeValue="{ item }">
              {{Number(item.ChargeValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.AllocationRate="{ item }">
              {{Number(item.AllocationRate).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:item.OpeningBalance="{ item }">
              {{Number(item.OpeningBalance).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template  v-slot:item.AllocationValue="{ item }">
              {{Number(item.AllocationValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
            </template>

            <template v-slot:footer >
              <v-divider class="mt-0"/>
              <div class="text-right mb-4 pt-7">
                <v-btn class="white--text" small color="#2A353D" @click="closeEdit()">close</v-btn>     
              </div>
            </template>
          </v-data-table>
        </template>

        <template v-slot:item.Status="{ item }">
          <v-chip outlined small color="success" v-if="(item.FldBit02 == 0 && item.FldInt01 == 0) || (item.FldBit02 == 0 && item.FldInt01 == 3)">running allocation</v-chip>
          <v-chip outlined small color="warning" v-if="item.FldBit02 == 0 && item.FldInt01 == 2">new allocation</v-chip>
          <v-chip outlined small color="error" v-if="item.FldBit02 == 1">fully terminated</v-chip>
          <v-chip outlined small color="cyan" v-if="item.FldBit02 == 2">split termination</v-chip>
        
          <!-- <span v-if="item.FldBit02 == 0 && item.FldInt01 < 1"><v-icon class="mr-2" small color="success">mdi-checkbox-blank-circle</v-icon></span>
          <span v-if="item.FldBit02 == 0 && item.FldInt01 > 0"><v-icon class="mr-2" small color="yellow">mdi-checkbox-blank-circle</v-icon></span>
          <span v-if="item.FldBit02 == 1"><v-icon class="mr-2" small color="red">mdi-checkbox-blank-circle</v-icon></span> -->
        </template>

        <template v-slot:item.AccountID="{ item }">
          {{allClientAccounts.filter(a => a.AccountID == item.AccountID).map(a => a.tblclient.MajorName)[0]}}   {{allClientAccounts.filter(a => a.AccountID == item.AccountID).map(a => a.tblclient.Forename)[0]}}
        </template>

        <template v-slot:item.AllocationValue="{ item }">
          {{Number(item.AllocationValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>

        <template v-slot:item.Accrued="{ item }">
          <span v-if="item.FldBit02 == 0">----</span>
          <span v-else>{{Number(getEachAccruedInterest(item.AllocationValue)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
        </template>

        <template v-slot:item.FldNum01="{ item }">
          {{Number(item.FldNum01).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})}}
        </template>

      </v-data-table>
    </v-card>
  </v-form>

<!-- ********************************************************************************************TABLE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    :headers="headers"
    :fixed-header="true"
    :items="confirmedSales ? Sales : Sales.filter(a => a.CheckerID === 0)"
    :search="search" v-if="!create && !edit"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >

      <v-dialog persistent v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus('',false); close()">
                <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                ok
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="reverseDialog" max-width="500px">
        <v-form flat ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="grey--text text-center">Deal Reversal</span>
            </v-card-title>

            <v-card-text>
              <span class="subtitle-1">{{reversal_description}}</span>

              <v-textarea
                class="mt-3"
                label="Reversal Reason"
                v-model="ReversalReason"
                outlined rows="6"
                row-height="15"
                :rules="TextFieldRules"
                placeholder="----"
              ></v-textarea>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-right mb-4">
                <v-btn class="white--text mr-3" small color="#2A353D" @click="reverseDialog = false">cancel</v-btn>
                <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="ReverseDeal()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  submit
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>          
        </v-form>
      </v-dialog>

      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true && DealerID > 0" v-show="confirmedSales" @click="overlay = true; showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-show="confirmedSales" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "MM Sales.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "MM Sales.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-show="confirmedSales" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency); __getInterestDenominator(); getCustodians()">

          <v-list-item-title>
            {{ Currency.CurrencyName }}
          </v-list-item-title>

          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-show="!confirmedSales" @click="confirmedSales = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0 && item.IsReversed == 0">rejected</v-chip>
      <v-chip outlined small color="error" v-if="item.IsReversed == 1">reversed</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0 && item.IsReversed == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0 && item.IsReversed == 0">confirmed</v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedSales && item.CheckerID == 0" top>
      </v-tooltip>
      <v-tooltip v-if="!confirmedSales && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="updateStatus(item, true)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedSales && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="reject(); setActiveSale(item, index)"
          outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        small outlined
        @click="view = true; setActiveSale(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-tooltip v-if="confirmedSales && DealerID > 0" top>
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            :disabled="showReverseBtn == true && item.CheckerID == 0 ? false : true"
            color="#2A353D" @click="setActiveSale(item, index); initReversal(item)"
          >
          mdi-backup-restore
          </v-icon>
        </template>
        <span>reverse</span>
      </v-tooltip>
    </template>

    <template v-slot:item.CustodialID="{ item }">
      {{getCustodianName(item.CustodialID)}}
    </template>

    <template v-slot:item.SaleDate="{ item }">
      {{ item.SaleDate | moment("DD MMM YYYY") }}
    </template> 

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import UserService from '../services/user.service';
import dealingService from '../services/dealing.service';
import transactionService from '../services/transaction.service';
import administrationService from '../services/administration.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      confirmedSales: true,
      edit: false,
      create:false,
      view: false,
      view_summary: true,
      dialog: false,
      reverseDialog: false,
      ReversalReason: '',
      reversal_description: '',
      message: '',
      DaysRun: 0,
      DaysToRun: 0,
      e1: 1,
      menu: false,
      menu_1: false,
      menu_2: false,
      loading: false,
      search: '',
      valid: true,
      permitted: null,
      permitted_dialog: true,
      currentAllocation: null,
      allocationIndex: -1,
      ActiveDeal: {},
      ActiveDealDetails: null,
      currentSale: null,
      currentIndex: -1,
      CurrentDataset: [],
      ChargesBoolean: [
        { Value: 1, Text: 'Yes'},
        { Value: 0, Text: 'No'}
      ],
      headers: [
        {
          text: 'Deal Note',
          align: 'start',
          sortable: true,
          value: 'BrokerNote'
        },
        { text: 'Custodian', value: 'CustodialID', sortable: false },
        { text: 'Sale Date', value: 'SaleDate', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      partial_termination_headers: [
        { value: 'Status', sortable: false},
        { text: 'Split Sell', value: 'Split', sortable: false, width: 220},
        { text: 'Name', value: 'AccountID', sortable: false},
        { text: 'Norminal Value', value: 'AllocationValue', sortable: false },
        { text: 'Accrued Interest', value: 'Accrued', sortable: false },
        { text: 'Maturity Value', value: 'FldNum01', sortable: false}
      ],
      full_termination_headers: [
        { value: 'Status', sortable: false},
        { text: 'Rate (%)', value: 'FldNum05', sortable: false, width: 220},
        { text: 'Name', value: 'AccountID', sortable: false},
        { text: 'Norminal Value', value: 'AllocationValue', sortable: false },
        { text: 'Accrued Interest', value: 'Accrued', sortable: false },
        { text: 'Maturity Value', value: 'FldNum01', sortable: false}
      ],
      termination_view_headers: [
        { value: 'Status', sortable: false},
        { text: 'Name', value: 'AccountID', sortable: false},
        { text: 'Norminal Value', value: 'AllocationValue', sortable: false },
        { text: 'Accrued Interest', value: 'Accrued', sortable: false },
        { text: 'Maturity Value', value: 'FldNum01', sortable: false}
      ],
      deal_summary_headers: [
        { text: 'Norminal Value', value: 'InstrumentValue', sortable: false },
        { text: 'Accrued Interest', value: 'Accrued', sortable: false },
        { text: 'Days run', value: 'DaysRun', sortable: false},
        { text: 'Days to run', value: 'DaysToRun', sortable: false },
        { text: 'Maturity Value', value: 'MaturityValue', sortable: false}
      ],
      allocations_headers: [
        { text: 'Account Name', value: 'AccountID', sortable: false, width: 180 },
        { text: 'Amount', value: 'AllocationValue', sortable: false, width: 170},
        { text: 'Rate (%)', value: 'AllocationRate', sortable: false, width: 90 },
        { text: 'O/Balance', value: 'OpeningBalance', sortable: false},
        { text: 'Charges', value: 'ChargeValue', sortable: false },
        { text: 'O/Profit', value: 'FldNum04',  sortable: false },
        { text: 'Maturity Value', value: 'FldNum01',  sortable: false },
        { value: 'action', sortable: false }
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      DateRules: [
        v => !!v || 'field is required',
        v => (v < this.ActiveDeal.MaturityDate && v > this.ActiveDeal.PurchaseDate) || 'Date must be between Purchase Date & Maturity Date'
      ],
      DeductedValueRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.MMSale.sale.InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
      ],
      DeductedUnitsRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(Number(this.MMSale.sale.InstrumentValue) + (Number(this.GrossInterest) - (Number(this.GrossInterest) * (Number(this.MMSale.sale.TaxRate) / 100)))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Maturity Value'
      ],
      EditDeductedValueRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(this.currentSale.InstrumentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
      ],
      EditDeductedUnitsRules: [
        v => !!v || 'field is required',
        v => (!!v && v == Number(Number(this.currentSale.InstrumentValue) + (Number(this.GrossInterest) - (Number(this.GrossInterest) * (Number(this.currentSale.TaxRate) / 100)))).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Quantity',
      ],
      CurrencyId: 0,
      selected: [],
      Deals: [],
      Accounts: [],
      Basis: [],
      DealCustodians: [],
      EarlyTerminationCharges: 0,
      ChargePercentage: 0,
      WithHoldingTax: 0,
      Profit_Loss: 0,
      SaleProceeds: 0,
      MarketValue: 0,
      AccruedInterest: 0,
      AccruedInterestDue: 0,
      GrossInterest: 0,
      MMRate: 0,
      TotalValue: 0,
      RejectionStatus: 0,
      MMSale: {
        allocation: [],
        termination: []
      },
      SaleDate: null,
      errors: [],
      BNerrors: [],
      BlockingViolation: null,
      InterestDenominator: 0,
      TerminationDirectives: [],
      CurrentTerminationDirective: {},
      ProprietaryAcc: {},
    }
  },

  computed: {
    ...mapGetters([
      "allInstrumentTypes",
      "allApplicationDefaults",
      "allMMSales",
      "allCurrencies",
      "allRejectionReasons",
      "allCounterparties",
      "allDealers",
      "allCustodians",
      "currentSystemDate",
      "allConfirmationSettings",
      "allMMPurchases",
      "allUsers",
      "allClientAccounts"
    ]),

    Termination_Allocations() {
      var allocations = [];
      if(this.ActiveDeal == {}){
        return allocations
      } else {
        var items = this.allMMPurchases.filter(a => a.CurrencyID == this.CurrencyId && a.PurchaseID == this.ActiveDeal.PurchaseID);
        for(let i = 0; i < items.length; i++){
          for(let j = 0; j < items[i].allocations.filter(a => a.FldBit02 == 0).length; j++){
            // items[i].allocations.filter(a => a.FldBit02 != 1)[j].Split = false,
            // items[i].allocations.filter(a => a.FldBit02 != 1)[j].SplitValue = 0,
            allocations.push(items[i].allocations.filter(a => a.FldBit02 == 0)[j])
          }
        }
        // allocations.forEach((allocation) => {
        //   allocation.SplitValue = 0
        // })
        return allocations
      }
    },

    InstrumentValue(){
      if(this.selected.length > 0){
        var SplitSum = this.selected.filter(s => s.Split == true).map(s => s.SplitValue == null || s.SplitValue == undefined ? 0 : Number(s.SplitValue)).reduce((a, b) => a + b, 0)
        var UnspiltSum = this.selected.filter(s => s.Split != true).map(s => Number(s.AllocationValue)).reduce((a, b) => a + b, 0)
        var SelectedSum = SplitSum + UnspiltSum
        // return SelectedSum + this.getEachAccruedInterest(SelectedSum)
        return SelectedSum
      } else {
        return 0
      }
    },

    TerminationMaturity(){
      if(this.selected.length > 0){
        var SplitSum = this.selected.filter(s => s.Split == true).length > 0 ? this.selected.filter(s => s.Split == true).map(s => Number(s.SplitValue/s.AllocationValue*s.FldNum01)).reduce((a, b) => a + b, 0) : 0;
        var UnsplitSum = this.selected.filter(s => s.Split != true).length > 0 ? this.selected.filter(s => s.Split != true).map(s => Number(s.FldNum01)).reduce((a, b) => a + b, 0) : 0;
        
        var MaturitySum = UnsplitSum + SplitSum
        return MaturitySum
      } else {
        return 0
      }
    },

    CurrentSaleOriginalDeal(){
      return this.allMMPurchases.filter(a => a.PurchaseID == this.currentSale.RefDeal)[0]
    },

    TerminatedAllocations(){
      var list = []
      if(this.currentSale != null){
        for(let i = 0; i < this.currentSale.deductions.length; i++){
          list.push(this.CurrentSaleOriginalDeal.allocations.filter(a => a.PurchaseAllocationID == this.currentSale.deductions[i].FldInt01)[0])
        }
        return list
      } else {
        return list
      }
    },

    currentUser() {
      return this.$store.state.auth.user;
    },
    Sales() {
      return this.allMMSales.filter(a => a.CurrencyID == this.CurrencyId);
    },
    Currency() {
      return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
    },
    DealerID() {
      return this.allDealers.filter(a => a.SystemUserID == this.currentUser.SecurityUserID).map(a => a.DealerID).toLocaleString();
    },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 203).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 203).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 203).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    showReverseBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 203).map(r => r.AllowReversal)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 203).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    },
  },

  watch: {
    selected: function(newValue){
      if(newValue.length == this.Termination_Allocations.length){
        dealingService.getTerminationDirectives({Param: 123})
        .then(response => {
          this.TerminationDirectives = response.data,
          this.CurrentTerminationDirective = response.data[1]
        })  
      } else if(newValue.length > 0){
        dealingService.getTerminationDirectives({Param: 1})
        .then(response => {
          this.TerminationDirectives = response.data,
          this.CurrentTerminationDirective = response.data[0]
        })  
      } else if(newValue.length == 0){
        this.TerminationDirectives = [],
        this.CurrentTerminationDirective = {},
        this.MMSale.allocation = []
      }
    },
    'CurrentTerminationDirective.TerminationDirectiveId': {
      handler: function(newValue) {
        this.MMSale.allocation = [];
        if(newValue == 3){

          dealingService.getProprietaryAcc({Param: 1})
          .then(response => {
            this.ProprietaryAcc = response.data[0];

            var data ={
              AccountID: this.ProprietaryAcc.AccountID,
              EffectiveDate: this.currentSystemDate.DayDate
            }
            transactionService.getAccountBalances(data.AccountID, data)
            .then(response => {           
              this.MMSale.allocation.push(
                {
                  AccountID: this.ProprietaryAcc.AccountID,
                  FldNum02: '',
                  FldNum01: '',
                  OpeningBalance: response.data[0].Available,
                  AllocationValue: this.InstrumentValue,
                  AllocationRate: '',
                  Charges: ''
                }
              )
            })
          })
        }
      },
      deep: true
    },
    ActiveDealDetails: function(newValue) {
      this.ActiveDeal = this.Deals.filter(d => d.Deal == newValue)[0];

      this.getDaysRun(this.ActiveDeal.PurchaseDate, this.currentSystemDate.DayDate);
      this.getDaysToRun(this.currentSystemDate.DayDate, this.ActiveDeal.MaturityDate);
    },
    SaleDate: function(newValue) {
      if(newValue != null){
        var data = {
          Date: newValue,
        };

        dealingService.checkIsWeekendHoliday(data)
        .then(response => {
          this.errors = response.data[0].Valid ? ['Date cannot be a weekend or holiday'] : []
        })        
      }
    },
    SaleProceeds: function() {
      this.getTradingProfit_Loss()
    },
    'MMSale.sale.BrokerNote': {
      handler: function(newValue) {
        if(newValue != null && newValue != ''){
          var data = {
            BrokerNote: newValue,
          };

          dealingService.checkBrokerNoteIsUnique(data)
          .then(response => {
            this.BNerrors = response.data[0].IsUnique ? [] : ['Deal Note already in use']
          })
        }
      },
      deep: true
    },
    'ActiveDeal.Deal': {
      handler: async function() {
        this.getDaysRun(this.ActiveDeal.PurchaseDate, this.currentSale.SaleDate);
        this.getDaysToRun(this.currentSale.SaleDate, this.ActiveDeal.MaturityDate);
      },
      deep: true
    },
  },

  created () {
    this.CurrencyId = this.allApplicationDefaults[0].CurrencyID
    this.__getInterestDenominator();
    this.getCustodians();
    this.getBasis();
  },

  methods: {
    ...mapActions([
      "createSale",
      "updateSale",
      "updateSaleStatus",
      "createReversal"
    ]),

     async createNew() {
      this.message = '';

      this.errors = this.selected.length > 0 ? [] : ['Select Beneficiaries for early termination']
      await this.validate()

      if (this.valid == true) {
        this.loading = true;
        this.MMSale.PurchaseID = this.ActiveDeal.PurchaseID,
        this.MMSale.InstrumentID = this.ActiveDeal.InstrumentID,
        this.MMSale.Nominal = this.InstrumentValue,
        this.MMSale.MakerID = this.currentUser.SecurityUserID,
        this.MMSale.CheckerID = this.CheckerID,
        this.MMSale.PurchaseDate = this.currentSystemDate.DayDate,
        this.MMSale.CurrencyID = this.CurrencyId,
        this.MMSale.DealerID = this.DealerID,
        this.MMSale.LastUserID = this.currentUser.SecurityUserID,
        this.MMSale.SaleType = this.selected.length == this.Termination_Allocations.length? 1 : 2,
        this.MMSale.AssetType = 4,
        this.MMSale.AllocationType = 1,
        this.MMSale.TerminationDirective = this.CurrentTerminationDirective.TerminationDirectiveId,
        this.MMSale.EarlyTerminationCharge = this.ChargePercentage == true ? (this.EarlyTerminationCharges / 100) * this.InstrumentValue : this.EarlyTerminationCharges,
        this.MMSale.ChargePercentage = this.ChargePercentage,

        this.MMSale.termination = this.selected,

        dealingService.createMMSale(this.MMSale)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'setSales',
            data: response.data.sales
          });
          this.$store.commit('setSales', response.data.sales);
          this.$socket.client.emit('socketreq', {
            commit: 'setPurchases',
            data: response.data.purchases
          });
          this.$store.commit('setPurchases', response.data.purchases);
          this.message = response.data.message
          this.loading = false;
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    async update() {
      this.message = '';

      await this.validate()

      if (this.valid == true) {
        this.loading = true;

        this.currentSale.MakerID = this.currentUser.SecurityUserID,
        this.currentSale.LastUserID = this.currentUser.SecurityUserID,
        this.currentSale.CheckerID = 0,
        this.currentSale.CheckDate = null,
        this.currentSale.MakeDate = new Date(),
        this.currentSale.RejectionID = this.RejectionStatus,

        this.currentSale.deductions = [],
        this.currentSale.charges = [],
        this.currentSale.taxes = [],

        this.updateSale(this.currentSale)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updSale',
            data: this.currentSale
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    updateStatus(item, status) {
      this.message = '';
      this.loading = true;

      if(status == true){
        item.CheckerID = this.currentUser.SecurityUserID,
        item.LastUserID = this.currentUser.SecurityUserID,
        item.CheckDate = new Date(),
        item.updatedAt = new Date(),
        item.RejectionID = this.RejectionStatus,
        item.IsConfirmation = status,

        dealingService.updateMMSaleStatus(item.SaleID, item)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updSale',
            data: item
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      } else {
        this.currentSale.CheckerID = this.currentUser.SecurityUserID,
        this.currentSale.LastUserID = this.currentUser.SecurityUserID,
        this.currentSale.CheckDate = new Date(),
        this.currentSale.updatedAt = new Date(),
        this.currentSale.RejectionID = this.RejectionStatus,
        this.currentSale.IsConfirmation = status,

        dealingService.updateMMSaleStatus(this.currentSale.SaleID, this.currentSale)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updSale',
            data: this.currentSale
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    getBasis() {
      this.message = '';
      dealingService.getDayCountBasis()
      .then(response => {
        this.Basis = response.data
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    initReversal(item){
      var data = {
        FunctionID: 203,
        EntryID: item.SaleID,
        ReversalDate: this.currentSystemDate.DayDate
      }
      
      dealingService.initReversal(data)
      .then(response => {
        if(response.data.validation[0].fnResultClass == 1){
          this.reverseDialog = true
          this.reversal_description = response.data.description[0][0].description
        } else {
          this.message = response.data.validation[0].fnResult
        }
      })
    },

    async ReverseDeal(){
      this.message = '';
      await this.validate()

      if (this.valid == true) {
        var data = {
          ReversalID: 0,
          FunctionID: 203,
          EntityID: this.currentSale.SaleID,
          ReversalReason: this.ReversalReason,
          ReversalDate: this.currentSystemDate.DayDate,
          MakerID: this.currentUser.SecurityUserID,
          CheckerID: 0,
          LastUserID: this.currentUser.SecurityUserID,
          RejectionID: 0,
        }

        this.createReversal(data)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'newReversal',
            data: response.data
          });
          
          this.message = response.data.message
          this.loading = false;
          this.reverseDialog = false;
          this.reversal_description = '';
          this.ReversalReason = '';
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })
      }
    },

    getDeals(PurchaseID, CustodialID) {
      var data = {
        ID: PurchaseID,
        CustodialID: CustodialID,
        CurrencyID: this.CurrencyId
      }
      this.message = '';
      dealingService.getRunningMMDeals(data)
      .then(response => {
        this.Deals = response.data
        if(this.edit == true){
          this.ActiveDeal = this.Deals[0]
        }
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getDaysRun(itemDate, saleDate) {
      var data = {
        PurchaseDate: itemDate,
        MaturityDate: saleDate,
      };

      if (itemDate != null && saleDate != null) {
        dealingService.getTenorDays(data)
        .then(response => {
          this.DaysRun = response.data[0].TenorDays
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getDaysToRun(saleDate, matuDate) {
      var data = {
        PurchaseDate: saleDate,
        MaturityDate: matuDate,
      };

      if (saleDate != null && matuDate != null) {
        dealingService.getTenorDays(data)
        .then(response => {
          this.DaysToRun = response.data[0].TenorDays
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    __getInterestDenominator(){
      if(this.MMSale.FldVar01 != null && this.MMSale.FldVar01 != ''){
        this.InterestDenominator = Number(this.Basis.filter(b => b.BasisIdAlpha == this.MMSale.FldVar01).map(b => b.Basis)[0])
      } else if(this.currentSale && this.currentSale.FldVar01 != null && this.currentSale.FldVar01 != '' ){
        this.InterestDenominator = Number(this.Basis.filter(b => b.BasisIdAlpha == this.currentSale.FldVar01).map(b => b.Basis)[0])
      } else {
        this.InterestDenominator = 0
      }
    },

    getInterestDenominator() {
      var data = {
        CurrencyID: this.CurrencyId,
      };

      if (this.CurrencyId != null) {
        dealingService.getInstrumentDenominator(data)
        .then(response => {
          this.InterestDenominator = response.data[0].InterestDenominator
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    checkDate(item) {
      var data = {
        Date: item,
      };

      if (item != null) {
        dealingService.checkIsWeekendHoliday(data)
        .then(response => {
          return response.data[0].Valid
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getCustodians() {
      this.message = '';
      var data ={
        CurrencyID: this.CurrencyId,
      }
      dealingService.getCustodians(data.CurrencyID)
      .then(response => {
        this.DealCustodians = response.data
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getNetValueValidation (body, item){
      var data = {
        ClientID: this.allClientAccounts.filter(a => a.AccountID == item.AccountID)[0].ClientID,
        CurrencyID: this.CurrencyId
      }
      administrationService.getNetValue(data.ClientID, data)
      .then(async response => {
        const netValue = await response.data[0].map(r => r.value)[0]

        const accounts = await this.allClientAccounts.filter(a => a.ClientID == data.ClientID).map(a => a.AccountID)

        const sub_total = await body.filter(b => accounts.includes(b.AccountID) == true).map(b => Number(b.AllocationValue)).reduce((a, b) => a + b, 0)

        const total = await sub_total + body.filter(b => accounts.includes(b.AccountID) == true).map(b => Number(b.ChargeValue)).reduce((a, b) => a + b, 0)

        if(Number(total) <= Number(netValue)){
          this.BlockingViolation = false
        } else{
          this.BlockingViolation = true
          item.AllocationValue = 0
        }
      })
      return this.BlockingViolation
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("MM Sales", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('MM Sales.pdf')
      }
    },

    getEachAccruedInterest(value){
      if(this.create == true){
        return value * ((this.ActiveDeal.Rate/100) * (this.DaysRun/this.InterestDenominator))
      } else {
        return value * ((this.CurrentSaleOriginalDeal.Rate/100) * (this.DaysRun/this.InterestDenominator))
      }
    },

    getAccruedInterest(item){
      this.AccruedInterest = item.InstrumentValue * ((item.Rate/100) * (this.DaysRun/this.InterestDenominator))
      return this.AccruedInterest
    },

    getAccruedInterestDue(){
      this.AccruedInterestDue = this.ActiveDeal.InstrumentValue * ((this.ActiveDeal.Rate/100) * (this.DaysToRun/this.InterestDenominator))
      return this.AccruedInterestDue
    },

    getProfit(item){
      // item.FldNum02 = (item.AllocationValue/this.InstrumentValue) * (this.TerminationMaturity - (this.InstrumentValue + this.getAccruedInterest(this.ActiveDeal)))
      item.FldNum04 = (this.ActiveDeal.Rate - item.AllocationRate)/100 * item.AllocationValue/this.InterestDenominator*this.DaysToRun
      return item.FldNum04
    },

    getMaturityValue(item){
      item.FldNum01 = Number(item.AllocationValue * (1 + ((item.AllocationRate/100) * (this.DaysToRun/this.InterestDenominator)))) - Number(item.ChargeValue)
      item.FldNum02 = item.FldNum01 - item.AllocationValue
      return item.FldNum01        
    },

    getMarketValue(){
      // if (this.selected.length == this.Termination_Allocations.length){
        this.MarketValue = this.ActiveDeal.InstrumentValue * (1 + ((this.ActiveDeal.ClientRate/100) * (this.DaysRun/this.InterestDenominator)))
        return this.MarketValue
      // } else {
      //   this.MarketValue = this.ActiveDeal.InstrumentValue * (1 + ((this.MMRate/100) * (this.DaysRun/this.InterestDenominator)))
      //   return this.MarketValue
      // }
    },

    getSaleProceeds(item){
      this.SaleProceeds = this.ActiveDeal.MaturityValue / (1 + ((item/100) * (this.DaysToRun/this.InterestDenominator)))
      return this.SaleProceeds
    },

    getTradingProfit_Loss(){
      this.Profit_Loss = (this.SaleProceeds - this.MarketValue).toFixed(2)
      return this.Profit_Loss
    },

    mapCurrency(currency) {
      return this.CurrencyId = currency.CurrencyID
    },

    allowedDates: val => val <= new Date().toISOString().split('T')[0],

    getCustodianName(id) {
      return this.allCustodians.filter(a => a.CustodianID === id).map(a => a.CustodianName).toLocaleString()
    },

    getInstrumentName(id) {
      return this.allInstrumentTypes.filter(a => a.InstrumentTypeID === id).map(a => a.InstrumentTypeCode).toLocaleString()
    },

    getAllocationCharges(item) {
      if(this.ChargePercentage == true){
        item.ChargeValue = (item.AllocationValue / this.InstrumentValue) * ((this.EarlyTerminationCharges / 100) * this.InstrumentValue);
      } else{
        item.ChargeValue = (item.AllocationValue / this.InstrumentValue) * this.EarlyTerminationCharges;
      }
      return item.ChargeValue
    },

    // getAllocationRate(item){
    //   item.AllocationRate = (item.FldNum01/item.AllocationValue - 1) * (this.InterestDenominator/this.DaysToRun) * 100
    //   return item.AllocationRate
    // },

    getCurrentAccountBalance(item) {
      this.message = '';
      var data ={
        AccountID: item.AccountID,
        EffectiveDate: this.currentSystemDate.DayDate
      }
      transactionService.getAccountBalances(data.AccountID, data)
      .then(response => {
        item.OpeningBalance = response.data[0].Available
        return item.OpeningBalance
      })
    },

    getAccounts(item) {
      var data = {
        CustodialID: item,
        CurrencyID: this.CurrencyId,
        Taxable: null,
        Counter: 0
      }
      dealingService.getCustodianAccounts(data.CustodialID, data)
      .then(response => {
        this.Accounts = response.data
      })
    },

    getAllocatedValue(item) {
      return item.map(i => Number(i.AllocationValue)).reduce((a, b) => a + b, 0);
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedSales = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.currentSale = null,
      this.EarlyTerminationCharges = 0,
      this.DaysRun = 0,
      this.DaysToRun = 0,
      this.ActiveDeal = {},
      this.ActiveDealDetails = null,
      this.Accounts = [],
      this.Deals = [],
      this.Profit_Loss = 0,
      this.SaleProceeds = 0,
      this.MarketValue = 0,
      this.AccruedInterest = 0,
      this.AccruedInterestDue = 0,
      this.MMRate = 0,
      this.edit = false
    },

    showCreate () {
      this.create = true;
    },

    closeCreate() {
      this.MMSale.sale = {},
      this.EarlyTerminationCharges = 0,
      this.DaysRun = 0,
      this.DaysToRun = 0,
      this.ActiveDeal = {},
      this.ActiveDealDetails = null,
      this.Accounts = [],
      this.Deals = [],
      this.Profit_Loss = 0,
      this.SaleProceeds = 0,
      this.MarketValue = 0,
      this.AccruedInterest = 0,
      this.AccruedInterestDue = 0,
      this.MMRate = 0,
      this.create = false
    },

    reject () {
      this.dialog = true
    },

    close () {
      this.dialog = false
      this.RejectionStatus = 0
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
      return this.valid
    },

    reset () {
      this.$refs.form.reset()
    },

    async setActiveSale (item, index) {
      await this.getAccounts(item.CustodialID);

      this.currentSale = item;
      this.currentIndex = index;

      this.DaysRun = item.DaysRun;
      this.DaysToRun = item.DaysToRun
    },

    NewAllocation(item) {
      item.push(
        {
          AccountID: null,
          FldNum02: '',
          FldNum01: '',
          OpeningBalance: '',
          AllocationValue: '',
          AllocationRate: '',
          Charges: ''
        }
      )
    },

    removeAllocation(item, parent) {
      const index = parent.findIndex(p => p.AccountID === item.AccountID);
      parent.splice(index, 1)
    },

    setActiveAllocation (item, index) {
      this.currentAllocation = item
      this.allocationIndex = index
    },

    setActiveDeal (item) {
      this.ActiveDeal = this.Deals.filter(d => d.Deal == item)[0]
    },
  },

  mounted () {
    UserService.isSellMoneyMarket().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedMMSales", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.edit {
  background-color: #DBEFFA;
}

.v-btn {
  outline: none
}

/* .v-select__selections input {
  display: none;
} */

.Account {
  width: 250px;
}

.my-allocations-table{
  table-layout : fixed;
}

.table-text-field{
  width: 170px;
}

.headline {
  color:white
}
</style>
